module.exports = __webpack_public_path__ + "img/image12.b3199262.webp";